"use client";
import dynamic from "next/dynamic.js";
import type { VoiceChangerV2Props } from "./VoiceChangerV2";

const VoiceChangerDemo = dynamic(() => import("./VoiceChangerV2").then(mod => mod.default));

export default function VoiceChangerV2Lazy(props: VoiceChangerV2Props) {
  return <VoiceChangerDemo {...props} />;
}
